import * as Yup from 'yup'

export const Schema = Yup.object().shape({
    amount: Yup.string().required('مبلغ وام الزامی می باشد'),
    num_repayments: Yup.string().required('اعداد اقساط الزامی می باشد'),
})

export const RequestNewLoanOptions: Array<ISelectOption> = [
    { label: 'فوری(کمتر از 3 روز)', value: 'URGENT' },
    { label: 'بالا(بین 3 تا 10 روز)', value: 'HIGH' },
    { label: 'متوسط(بین 10 تا 30 روز)', value: 'MID' },
    { label: 'پایین(بیشتر از 30 روز)', value: 'LOW' },
]
